module.exports = __webpack_public_path__ + "img/noVideo.17db5d28.png";